<script setup lang="ts">
import { useEditorStore } from '@/stores/Editor'
import { capitalize } from '@/helpers/utils'
import { constants } from '@/constants'
import { rules } from '@/helpers/rules'

import FormGroup from '@/components/common/FormGroup.vue'

const store = useEditorStore()
</script>

<template>
  <FormGroup
    v-for="(link, key) in store.editor.hero.links"
    :key="key"
    :label="capitalize(key)"
    :label-for="key"
    layout="cols"
  >
    <v-text-field
      v-model="store.editor.hero.links[key]"
      :id="key"
      variant="outlined"
      flat
      :rules="[rules.url, rules.maxlength()]"
      :disabled="store.publishLoading"
      :placeholder="constants.socialMediaLinks[key]"
    />
  </FormGroup>
</template>

<style lang="scss" scoped></style>
